import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import '../report.css';
import './dateFilter.css';
import { useTranslation } from 'react-i18next';
import ApiService from '../../../../services/apiService';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

const ReportsDashboard = () => {
  const [view, setView] = useState('month');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);

  // Branch dropdown states
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const getFormattedDate = (date) => new Date(date).toISOString().slice(0, 16);

  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  // -------------------------
  // ⭐ Fetch Branch List
  // -------------------------
  const fetchBranches = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_BRANCH');
      const list = res?.data?.result || [];

      const mapped = list.map((b) => ({
        value: b.id,
        label: b.branchName,
      }));

      setBranches(mapped);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  // -------------------------
  // Fetch Currency (existing)
  // -------------------------
  const GetCurrency = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_CURRENCY');
      const filtered = res?.data?.result?.find((c) => c?.default === true);
      setSelectedCurency(filtered);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  useEffect(() => {
    fetchBranches();
    GetCurrency();
  }, []);

  // -------------------------
  // ⭐ Fetch Dashboard Data with Branch Fix
  // -------------------------
  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();

      params.append('StartDate', formData.fromDate);
      params.append('EndDate', formData.toDate);

      // ⭐ FIX: Always send BranchId → if null send 0
      params.append('BranchId', selectedBranch?.value || 0);

      const res = await apiService.getApiParamater('GET_REPORT_DASHBOARD', `?${params.toString()}`);

      setData(res?.data?.result || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-lg-5">
      <button className="btn addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div>
        <div className="row">
          {/* ⭐ Branch Dropdown */}
          <div className="col-3">
            <label className="form-label">Select Branch</label>

            <Select
              value={selectedBranch}
              onChange={(opt) => setSelectedBranch(opt)}
              options={branches}
              placeholder="Select Branch"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                menu: (base) => ({ ...base, zIndex: 999999 }),
              }}
              isClearable
            />
          </div>

          <div className="col-3">
            <label className="form-label">
              {t('from')} {t('date')}
            </label>
            <input type="date" className="form-control" value={formData.fromDate} onChange={handleInputChange} name="fromDate" />
          </div>

          <div className="col-3">
            <label className="form-label">
              {t('to')} {t('date')}
            </label>
            <input type="date" className="form-control" value={formData.toDate} onChange={handleInputChange} name="toDate" />
          </div>

          <div className="col-3 mt-3">
            <button className="mt-3 addItem-btn" onClick={getReportData}>
              {t('Search')}
            </button>
          </div>
        </div>
      </div>

      {/* ---------------------------- */}
      {/* DASHBOARD CARDS */}
      {/* ---------------------------- */}
      <div className="pt-5 Dashboard-grid p-0">
        <div className="Dashboard-card">
          <h4>{t('revenue')}</h4>
          <h3>
            {SelectedCurrency?.code} {data?.revenue?.toFixed(2)}
          </h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('sale_count')}</h4>
          <h3>{data?.saleCount || 0}</h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('customer_count')}</h4>
          <h3>{data?.customerCount}</h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('gross_profit')}</h4>
          <h3>
            {SelectedCurrency?.code} {data?.grossProfit?.toFixed(2)}
          </h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('discount')}</h4>
          <h3>
            {SelectedCurrency?.code} {data?.discountedAmount?.toFixed(2)}
          </h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('discount')} %</h4>
          <h3>{data?.discountedPercent?.toFixed(2) || 0}%</h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('avg_sale_value')}</h4>
          <h3>
            {SelectedCurrency?.code} {data?.avgSaleValue?.toFixed(2)}
          </h3>
        </div>

        <div className="Dashboard-card">
          <h4>{t('avg_items_per_sale')}</h4>
          <h3>{data?.avgItemsPerSale?.toFixed(2)}</h3>
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(ReportsDashboard);
